import { createSvgIconComponent } from "../utils";

export const IconMonitor = createSvgIconComponent({
  path: "M15 1.52H1a1.01 1.01 0 0 0-1 1.03v8.86a1.01 1.01 0 0 0 1 1.02h5.67v1.36h-2a.34.34 0 0 0 0 .69h6.66a.34.34 0 0 0 0-.69h-2v-1.36H15a1.01 1.01 0 0 0 1-1.02V2.55a1.01 1.01 0 0 0-1-1.03zm-.33 9.55H1.33V2.89h13.34z",
  fill: "currentColor",
  viewBox: "0 0 16 16",
});
